<template>
  <v-dialog v-model="dialog" persistent width="900">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline m-0">
        <v-flex xs9> <v-icon>add</v-icon> Asignación Horario </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text class="p-0">
          <v-container grid-list-md style="min-width: 100%;" class="py-0 px-4">
            <v-layout wrap>
              <v-flex xs12 md12>
                <v-radio-group v-model="tipo_asignacion">
                  <v-radio label="Continuo" value="1"></v-radio>
                  <v-radio label="Discontinuo" value="2"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="form.fecha_desde"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  label="Fecha de inicio"
                  type="date"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="form.fecha_hasta"
                  :rules="$validate(['required'])"
                  required
                  label="Fecha de finalización"
                  type="date"
                  outline
                  clearable
                >
                </v-text-field>
              </v-flex>
              <v-flex :class="tipo_asignacion === '1' ? 'md12' : 'md6'">
                <v-select
                  :items="horarios"
                  :item-value="val => parseInt(val.id)"
                  :item-text="
                    val =>
                      val.descripcion +
                      ': ' +
                      $moment(val.hora_inicio, 'HH:mm:ss').format('HH:mm') +
                      ' - ' +
                      $moment(val.hora_fin, 'HH:mm:ss').format('HH:mm')
                  "
                  :label="
                    tipo_asignacion === '1'
                      ? 'Seleccione un horario'
                      : 'Seleccione primer horario'
                  "
                  v-model="form.id_horario"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                ></v-select>
              </v-flex>
              <v-flex md6 v-if="tipo_asignacion === '2'">
                <v-select
                  :items="horarios"
                  :item-value="val => parseInt(val.id)"
                  :item-text="
                    val =>
                      val.descripcion +
                      ': ' +
                      $moment(val.hora_inicio, 'HH:mm:ss').format('HH:mm') +
                      ' - ' +
                      $moment(val.hora_fin, 'HH:mm:ss').format('HH:mm')
                  "
                  label="Seleccione segundo horario"
                  v-model="form.id_horario2"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones
export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
      horarios: [],
      persona: {},
      tipo_asignacion: "1"
    };
  },
  watch: {},
  mounted() {
    this.obtenerHorarios();
    this.$bus.$on("openDialogPersonaHorario", item => {
      this.persona = item;
      //this.form.fecha_hasta = "2024-12-31";
      this.dialog = true;
    });
  },
  methods: {
    async obtenerHorarios() {
      try {
        let res = await this.$service.graphql({
          query: `
						query{
							horarios{
								rows{
									id
									descripcion
                  hora_inicio
                  hora_fin
								}
							}
						}
					`
        });
        this.horarios = res.horarios.rows;
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.form = {};
      this.loading = false;
      this.persona = [];
      this.valid = false;
      this.$bus.$emit("closeDialog");
      this.dialog = false;
    },
    async save() {
      let user = this.$storage.get("user");
      if (this.$refs.form.validate()) {
        try {
          this.loading = true;
          if (this.tipo_asignacion == 1) {
            //horario continuo
            let res = await this.$service.graphql({
              query: `query{
                      runQuery(consulta:"select control.fn_registra_horario_por_funcionario(${this.persona.id},${this.form.id_horario},'${this.form.fecha_desde}',${user.id},'${this.form.fecha_hasta}')"){
                        respuesta
                      }
                    }
                  `
            });
            if (
              res.runQuery.respuesta[0].fn_registra_horario_por_funcionario ===
              "1"
            ) {
              this.$bus.$emit("closeDialog");
              this.$message.success();
              this.close();
            } else {
              this.$message.error("Ocurrió un error en la operación");
            }
          } else {
            //horario discontinuo =2
            let res = await this.$service.graphql({
              query: `query{
                      runQuery(consulta:"select control.fn_asigna_horario_por_funcionario_discontinuo(${this.persona.id},${this.form.id_horario},${this.form.id_horario2},'${this.form.fecha_desde}',${user.id},'${this.form.fecha_hasta}')"){
                        respuesta
                      }
                    }
                  `
            });

            let respu =
              res.runQuery.respuesta[0]
                .fn_asigna_horario_por_funcionario_discontinuo;
            respu = respu.split("|");
            if (respu[0] == "1") {
              this.$bus.$emit("closeDialog");
              this.$message.success();
              this.close();
            } else {
              this.$message.error("Ocurrió un error en la operación");
            }
          }
          this.loading = false;
        } catch (error) {
          console.log(error);
        }
      }
    },

    


  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/asignacion_horario/dialogs/PersonaHorario.vue